import { ENDPOINTS } from "@/settings/api-settings";
import { Observable, from } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";


export function phonenumberValidationPostpone(): Observable<any> {
  return from(
    apiClient.post(`${ENDPOINTS.LOGIN_CELLPHONE_VALIDATION_POSTPONE}`),
  ).pipe(map((r: any) => r.data));
}

export function initValidation(cellphone): Observable<any> {
  return from(
    apiClient.post(`${ENDPOINTS.LOGIN_CELLPHONE_VALIDATION}`, { valor: cellphone }),
  ).pipe(map((r: any) => r.data));
}

export function finishValidation(code): Observable<any> {
  return from(
    apiClient.put(`${ENDPOINTS.LOGIN_CELLPHONE_VALIDATION}`, { valor: code }),
  ).pipe(map((r: any) => r.data));
}